import React, { useState, useEffect } from 'react';
import './Banner.css';
import bannerImage from '../../Assets/banner.png';
import bannerImageMob from '../../Assets/banner-mob.png';

const Banner = ({LearnClicked}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 608);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="banner">
      <img src={isMobile ? bannerImageMob : bannerImage} alt="Banner" />
      <div className="banner-content">
        <h1 className="banner-text">Portable Power at your fingertips</h1>
        <p className="banner-text-body">Charging solutions for people on the go. Never worry about running out of battery again!</p>
        <button className="learn-button" onClick={LearnClicked}>Learn More</button>
      </div>
    </div>
  );
};

export default Banner;



// WEBPACK FOOTER //
// ./src/components/Banner/Banner.js